import { IAction } from '../../../__core/Interfaces/IAction';
import { CourseDetailsResponse } from '../Types/CourseDetailsResponse';
import { CourseInstanceResponse } from '../Types/CourseInstanceResponse';
import { CourseReducer } from '../Types/CourseReducer';
import { courseInitState } from './CourseInitState';
import { courseDetailsReducer } from './CourseDetails';
import { courseInstanceReducer } from './CourseInstance';
import { courseResultsReducer } from './CourseResults';
import { CourseProgressResponse } from '../Types/CourseProgressResponse';

type CourseReducerAction =
  | IAction<CourseDetailsResponse>
  | IAction<CourseInstanceResponse>
  | IAction<CourseProgressResponse>;

export const courseReducer = (
  state: CourseReducer = courseInitState,
  action: CourseReducerAction
): CourseReducer => ({
  courseDetails: courseDetailsReducer(
    state.courseDetails,
    action as IAction<CourseDetailsResponse>
  ),
  courseInstance: courseInstanceReducer(
    state.courseInstance,
    action as IAction<CourseInstanceResponse>
  ),
  courseProgress: courseResultsReducer(
    state.courseProgress,
    action as IAction<CourseProgressResponse>
  ),
});
